"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _feefoHighlightedSnippets = _interopRequireDefault(require("./feefo-highlighted-snippets.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FeefoHighlightedSnippets = function FeefoHighlightedSnippets(props) {
  var vehicleSkuId = props.data.vehicleSkuId,
      feefoSnippetKey = props.compProps.feefoSnippetKey;
  (0, _react.useEffect)(function () {
    window.onload = function () {
      document.querySelectorAll("." + _feefoHighlightedSnippets["default"].feefoSnippetsWrapper + " .snippet-wrapper").forEach(function (element) {
        element.removeAttribute('role');
      });
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_feefoHighlightedSnippets["default"].feefoSnippetsWrapper),
    "data-feefowidget-st-snippets": feefoSnippetKey,
    "data-product-sku": vehicleSkuId
  });
};

FeefoHighlightedSnippets.resourceType = function () {
  return 'FeefoHighlightedSnippets_1_0_0';
};

FeefoHighlightedSnippets.displayName = 'FeefoHighlightedSnippets';
var _default = FeefoHighlightedSnippets;
exports["default"] = _default;